"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.redirectHook = redirectHook;

var _urlSearchParams = _interopRequireDefault(require("@ungap/url-search-params"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function redirectHook(router) {
  var searchParams = new _urlSearchParams["default"](router.location.search);
  var redirectTo = searchParams.get('redirect');
  var finalRedirect = '/';

  if (redirectTo) {
    var decoded = decodeURIComponent(redirectTo);

    if (extractHostname(decoded) === extractHostname(document.location.origin)) {
      finalRedirect = new URL(decoded).pathname;
    }
  }

  return finalRedirect;
}

function extractHostname(url) {
  var hostname; //find & remove protocol (http, ftp, etc.) and get hostname

  if (url.indexOf('//') > -1) {
    hostname = url.split('/')[2];
  } else {
    hostname = url.split('/')[0];
  } //find & remove port number


  hostname = hostname.split(':')[0]; //find & remove "?"

  hostname = hostname.split('?')[0];
  return hostname;
}